import { ButtonItem, Form, FormRef, GroupItem, RangeRule, RequiredRule, SimpleItem } from 'devextreme-react/form'
import { useRef } from 'react'
import { ArraySourceComposer } from '@/auth/api/connector'
import { task, user } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { LoadPanel, NumberBox, Popup } from 'devextreme-react'
import { ValueChangedEvent as ValueChangedEventNumberBox } from 'devextreme/ui/number_box'
import { ValueChangedEvent as ValueChangedEventSlider } from 'devextreme/ui/slider'
import { NumberBoxRef } from 'devextreme-react/cjs/number-box'
import { useScreenSize } from '@/themes/media-query'
import { PopupRef } from 'devextreme-react/cjs/popup'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import notify from 'devextreme/ui/notify'
import { LoadPanelRef } from 'devextreme-react/cjs/load-panel'
import { ClickEvent } from 'devextreme/ui/button'
import { DataGridRef, NumericRule } from 'devextreme-react/cjs/data-grid'
import { onInitializedHtmlEditor, onValueChangedHtmlEditor } from '@/routes/utils'
import { FocusOutEvent, ValueChangedEvent as ValueChangedEventDateBox } from 'devextreme/ui/date_box'
import { DateBoxTypes } from 'devextreme-react/cjs/date-box'
import { AxiosError, AxiosResponse } from 'axios'
import { getApiErrorMessage } from '@/auth/api/apiErrorMessage'
import saveAs from 'file-saver'

export type CommissionsSelectorProps = {
  popupRef: React.RefObject<PopupRef>
}

export const CommissionsSelector = (props: CommissionsSelectorProps) => {
  const { popupRef } = props
  const formRef = useRef<FormRef>(null)
  const currentScreenSize = useScreenSize()
  const { client } = useQsAdminApiManager()
  const loadPanelRef = useRef<LoadPanelRef>(null)

  const now: Date = new Date()

  const formatter = new Intl.DateTimeFormat('it', {
    month: 'long',
  })

  const formData: {
    fiscalYear: { index: number; description: string }
    month: { index: number; description: string }
    period: { index: number; description: string }
  } = {
    fiscalYear: { index: 2, description: (now.getFullYear() + 1).toString() },
    month: {
      index: now.getMonth(),
      description: formatter.format(new Date(now.getFullYear(), now.getMonth())),
    },
    period: {
      index: 1,
      description: 'Day 1-15',
    },
  }

  const monthList = [
    {
      index: 1,
      description: formatter.format(new Date(now.getFullYear(), 0)),
    },
    {
      index: 2,
      description: formatter.format(new Date(now.getFullYear(), 1)),
    },
    {
      index: 3,
      description: formatter.format(new Date(now.getFullYear(), 2)),
    },
    {
      index: 4,
      description: formatter.format(new Date(now.getFullYear(), 3)),
    },
    {
      index: 5,
      description: formatter.format(new Date(now.getFullYear(), 4)),
    },
    {
      index: 6,
      description: formatter.format(new Date(now.getFullYear(), 5)),
    },
    {
      index: 7,
      description: formatter.format(new Date(now.getFullYear(), 6)),
    },
    {
      index: 8,
      description: formatter.format(new Date(now.getFullYear(), 7)),
    },
    {
      index: 9,
      description: formatter.format(new Date(now.getFullYear(), 8)),
    },
    {
      index: 10,
      description: formatter.format(new Date(now.getFullYear(), 9)),
    },
    {
      index: 11,
      description: formatter.format(new Date(now.getFullYear(), 10)),
    },
    {
      index: 12,
      description: formatter.format(new Date(now.getFullYear(), 11)),
    },
  ]
  const periodList = [
    {
      index: 1,
      description: 'Day 1-15',
    },
    {
      index: 2,
      description: 'Day 16-EOM',
    },
    {
      index: 3,
      description: 'Monthly',
    },
  ]
  const fiscalYearList = [
    {
      index: 1,
      description: now.getFullYear().toString(),
    },
    {
      index: 2,
      description: (now.getFullYear() + 1).toString(),
    },
  ]

  return (
    <>
      <Popup
        width={currentScreenSize.isLarge || currentScreenSize.isMedium ? 300 : currentScreenSize.isXSmall ? 350 : 300}
        height={currentScreenSize.isSmall ? 320 : currentScreenSize.isXSmall ? 720 : 'auto'}
        hideOnOutsideClick={true}
        title="Commissioni Agenti"
        showCloseButton={true}
        deferRendering={true}
        ref={popupRef}
        onHiding={() => {}}
        resizeEnabled={false}
      >
        <div id="commissions-selector-form-container" className={'dx-card responsive-paddings'}>
          {/* <LoadingPanel
            position={{ of: '#outlook-appointment-selector-form-container' }}
            visible={loadIndicatorVisible}
          ></LoadingPanel> */}
          <LoadPanel
            ref={loadPanelRef}
            shadingColor="rgba(0,0,0,0.4)"
            showIndicator={true}
            shading={true}
            showPane={true}
            hideOnOutsideClick={false}
            hideOnParentScroll={false}
            position={{ of: '#commissions-selector-form-container' }}
          />

          <Form
            id={`commissions-selector-form}`}
            key={`commissions-selector-form}`}
            formData={formData}
            ref={formRef}
            validationGroup="commissionsSelectorValidation"
          >
            <GroupItem colCount={1}>
              <SimpleItem
                dataField="fiscalYear"
                label={{ text: 'Anno fiscale' }}
                editorType="dxLookup"
                editorOptions={{
                  dataSource: ArraySourceComposer('index', fiscalYearList),
                  placeholder: 'Seleziona anno fiscale...',
                  displayExpr: 'description',
                  searchEnabled: true,
                  dropDownCentered: true,
                  dropDownOptions: {
                    showTitle: true,
                    title: 'Selezionare anno fiscale',
                    hideOnOutsideClick: true,
                  },
                }}
              >
                <RequiredRule message="Anno fiscale obbligatorio"></RequiredRule>
              </SimpleItem>
              <SimpleItem
                dataField="month"
                label={{ text: 'Mese' }}
                editorType="dxLookup"
                editorOptions={{
                  dataSource: ArraySourceComposer('index', monthList),
                  placeholder: 'Seleziona mese...',
                  displayExpr: 'description',
                  searchEnabled: true,
                  dropDownCentered: true,
                  dropDownOptions: {
                    showTitle: true,
                    title: 'Selezionare mese',
                    hideOnOutsideClick: true,
                  },
                }}
              >
                <RequiredRule message="Mese obbligatorio"></RequiredRule>
              </SimpleItem>
              <SimpleItem
                dataField="period"
                label={{ text: 'Periodo' }}
                editorType="dxLookup"
                editorOptions={{
                  dataSource: ArraySourceComposer('index', periodList),
                  placeholder: 'Seleziona periodo...',
                  displayExpr: 'description',
                  searchEnabled: true,
                  dropDownCentered: true,
                  dropDownOptions: {
                    showTitle: true,
                    title: 'Selezionare periodo',
                    hideOnOutsideClick: true,
                  },
                }}
              >
                <RequiredRule message="Periodo obbligatorio"></RequiredRule>
              </SimpleItem>
            </GroupItem>
            <GroupItem cssClass="last-group">
              <GroupItem cssClass="buttons-group" colCount={1}>
                <ButtonItem
                  name="btn-compute"
                  buttonOptions={{
                    icon: 'group',
                    text: 'Esporta',
                    // disabled: false,
                    width: '150px',
                    onClick: async (e: ClickEvent) => {
                      const validationResult = formRef.current?.instance().validate()
                      if (!validationResult?.isValid) return
                      loadPanelRef.current?.instance().option('visible', true)
                      client
                        .get(
                          `/api/autodeskformaai/commissions?month=${formData.month.index}&period=${formData.period.index}&fiscalYear=${formData.fiscalYear.description}`,
                          {
                            headers: {
                              'Content-Disposition': `attachment;filename=Commissioni.zip`,
                              'Content-Type': 'application/octet-stream',
                            },
                            responseType: 'arraybuffer',
                          },
                        )
                        .then((response: AxiosResponse) => {
                          saveAs(new Blob([response.data], { type: 'application/octet-stream' }), `Commissioni.zip`)
                        })
                        .catch((error: AxiosError) => {
                          notify(
                            `Errore esportazione commissioni. Dettagli: ${getApiErrorMessage(error, 'errore imprevisto.')}`,
                            'error',
                            6000,
                          )
                        })
                        .finally(() => {
                          loadPanelRef.current?.instance().option('visible', false)
                          popupRef.current?.instance().hide()
                        })
                    },
                  }}
                ></ButtonItem>
              </GroupItem>
            </GroupItem>
          </Form>
        </div>
      </Popup>
    </>
  )
}

export default CommissionsSelector
